import { render } from "./VoucherDetail.vue?vue&type=template&id=248165c0&scoped=true"
import script from "./VoucherDetail.vue?vue&type=script&lang=js"
export * from "./VoucherDetail.vue?vue&type=script&lang=js"

import "./VoucherDetail.vue?vue&type=style&index=0&id=248165c0&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248165c0"]])

export default __exports__